module.exports = __webpack_public_path__ + "static/media/13.af2706f5.jpg";